import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { userActions } from '../../store/user/userSlice';
import { clearAuthContextStorage } from '../../store/user/userService';
import AppHeader from '../../components/AppHeader';

const NAV_ITEMS = [
  { to: '/affiliate/dashboard', label: 'Overview' },
];

export const AffiliateLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.removeItem('token');
    clearAuthContextStorage();
    dispatch(userActions.setToken(''));
    dispatch(userActions.clearAuthContext());
    navigate('/login', { replace: true });
  };

  return (
    <Shell>
      <AppHeader items={NAV_ITEMS} onLogout={handleLogout} />
      <Content>
        <Outlet />
      </Content>
    </Shell>
  );
};

export default AffiliateLayout;

const Shell = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.black};
  color: ${(props) => props.theme.white};
`;

const Content = styled.main`
  flex: 1;
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;
